import { AppBuildMode } from "./envConfig";

export const URL_API = AppBuildMode(process.env.REACT_APP_BUILD_MODE).API;
export const URL_API_PDULI = AppBuildMode(
  process.env.REACT_APP_BUILD_MODE
).API_PDULI;
export const URL_WS = AppBuildMode(process.env.REACT_APP_BUILD_MODE).URLWS;
